import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { RoutingRuleAction } from '@cbridge-packages/routing-rules';
import { RulesManagementAction } from '@cbridge-modules/rules-management-page';

export const onValidateRoutingRulesDoneEpic: IEpic = (action$) => action$.pipe(
  isTypeOfAndGetPayload(
    RoutingRuleAction.validate.done,
  ),
  mergeMap((payload) => {
    return [RulesManagementAction.applyValidation(payload.result)];
  }),
);
